export const WHATSAPP_DISPLAY = "+55 24 99213-6877";
export const WHATSAPP_LINK =
    "https://wa.me/5524992136877?text=Ol%C3%A1!%20Gostaria%20de%20solicitar%20um%20diagn%C3%B3stico%20estrat%C3%A9gico%20para%20minha%20empresa.";

export const LOGO_FULL = "/assets/vorantis-logo-t.png";
export const LOGO_MARK = "/assets/vorantis-mark.png";

export const NAV_LINKS = [
    { label: "Início", path: "/", testid: "nav-link-inicio" },
    { label: "Quem Somos", path: "/quem-somos", testid: "nav-link-quem-somos" },
    { label: "Soluções", path: "/solucoes", testid: "nav-link-solucoes" },
    { label: "Como Trabalhamos", path: "/como-trabalhamos", testid: "nav-link-como-trabalhamos" },
    { label: "Contato", path: "/contato", testid: "nav-link-contato" },
];

export const AREAS_INTERESSE = [
    "Gestão e Processos",
    "Posicionamento Digital",
    "Gestão + Posicionamento Digital",
    "Diagnóstico estratégico",
];

export const IMAGES = {
    hero_executive:
        "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMHN0cmF0ZWd5JTIwY29uc3VsdGluZyUyMHRlYW0lMjBtZWV0aW5nfGVufDB8fHx8MTc5MTUyOTI4Nnww&ixlib=rb-4.1.0&q=85",
    gestao_processos:
        "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMHN0cmF0ZWd5JTIwY29uc3VsdGluZyUyMHRlYW0lMjBtZWV0aW5nfGVufDB8fHx8MTc5MTUyOTI4Nnww&ixlib=rb-4.1.0&q=85",
    posicionamento_digital:
        "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBkaWdpdGFsJTIwdHJhbnNmb3JtYXRpb24lMjBhbmFseXRpY3MlMjBvZmZpY2V8ZW58MHx8fHwxNzkxNTI5Mjg2fDA&ixlib=rb-4.1.0&q=85",
    office_architectural:
        "https://images.unsplash.com/photo-1779700314631-1f18b467e0a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwY29ycG9yYXRlJTIwb2ZmaWNlJTIwYXJjaGl0ZWN0dXJlJTIwZGVzaWdufGVufDB8fHx8MTc5MTUyOTI4Nnww&ixlib=rb-4.1.0&q=85",
    team_collaboration:
        "https://images.unsplash.com/photo-1624555130581-1d9cca783bc0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMHN0cmF0ZWd5JTIwY29uc3VsdGluZyUyMHRlYW0lMjBtZWV0aW5nfGVufDB8fHx8MTc5MTUyOTI4Nnww&ixlib=rb-4.1.0&q=85",
    analytics_growth:
        "https://images.unsplash.com/photo-1531973576160-7125cd663d86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBkaWdpdGFsJTIwdHJhbnNmb3JtYXRpb24lMjBhbmFseXRpY3MlMjBvZmZpY2V8ZW58MHx8fHwxNzkxNTI5Mjg2fDA&ixlib=rb-4.1.0&q=85",
};

export const METODO_ETAPAS = [
    {
        numero: "01",
        titulo: "Entender",
        descricao: "Conhecemos a empresa, seus objetivos e sua realidade.",
    },
    {
        numero: "02",
        titulo: "Diagnosticar",
        descricao: "Identificamos prioridades e oportunidades concretas.",
    },
    {
        numero: "03",
        titulo: "Planejar",
        descricao: "Definimos escopo, entregáveis e etapas de implantação.",
    },
    {
        numero: "04",
        titulo: "Executar e acompanhar",
        descricao: "Implementamos as soluções e avaliamos ajustes necessários.",
    },
];
